import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  border: 1px solid #a8a8a8;\n  margin-bottom: 0.5em;\n  width: 100%;\n  font-size: 18px;\n  padding: 0.75em;\n\n  ', '\n'], ['\n  border: 1px solid #a8a8a8;\n  margin-bottom: 0.5em;\n  width: 100%;\n  font-size: 18px;\n  padding: 0.75em;\n\n  ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n      border: 2px solid ', ' !important;\n    '], ['\n      border: 2px solid ', ' !important;\n    ']),
    _templateObject3 = _taggedTemplateLiteral(['\n  color: ', ';\n  font-size: 12px;\n  font-weight: 500;\n  margin: 0 0 5px;\n  text-transform: capitalize;\n'], ['\n  color: ', ';\n  font-size: 12px;\n  font-weight: 500;\n  margin: 0 0 5px;\n  text-transform: capitalize;\n']);

import React from 'react';
import styled, { css } from 'styled-components';

// eslint-disable-next-line no-unused-vars
var StyledInput = styled(function (_ref) {
  var error = _ref.error,
      props = _objectWithoutProperties(_ref, ['error']);

  return React.createElement('input', props);
})(_templateObject, function (_ref2) {
  var error = _ref2.error;
  return error && css(_templateObject2, function (props) {
    return props.theme.dormifyRed;
  });
});

export { StyledInput };
export var StyledLabel = styled.p(_templateObject3, function (props) {
  return props.theme.dormifyGrey;
});